import { Helmet } from 'react-helmet-async'
import { useState, useEffect } from 'react'
import { api } from 'src/api/root'
import { useTenantStore } from 'src/enviroment/store/tenentStore'
import RAMOMembersTemplate from 'src/templates/members/RAMOMembersTemplate'

export default function TeamPage() {
  const { data, isLoading, hasNextPage, isFetchingNextPage, fetchNextPage } = api.member.list.useInfiniteQuery()
  const currentTenant = useTenantStore((state) => state.currentTenant)
  const uploadLogo = api.tenant.uploadLogo.useMutation()
  const [logoPreview, setLogoPreview] = useState<string | null>(currentTenant?.logoUrl || null)

  useEffect(() => {
    setLogoPreview(currentTenant?.logoUrl || null)
  }, [currentTenant?.id])
  const [searchTerm, setSearchTerm] = useState<string>('')
  const handleSearch = (value: string) => {
    setSearchTerm(value)
  }

  const handleRemoveLogo = () => {
    setLogoPreview(null)
  }

  const handleUpdateLogo = async (file: File) => {
    const { logoUrl } = await uploadLogo.mutateAsync(file)
    setLogoPreview(logoUrl)
  }

  const filteredMembers =
    data?.pages.flat().filter((member) => {
      if (!searchTerm) return true

      const lowercaseSearch = searchTerm.toLowerCase()
      return (
        member.email?.toLowerCase().includes(lowercaseSearch) ||
        member.firstName?.toLowerCase().includes(lowercaseSearch) ||
        member.lastName?.toLowerCase().includes(lowercaseSearch) ||
        member.company?.toLowerCase().includes(lowercaseSearch) ||
        member.tenantMemberAccess.role?.toLowerCase().includes(lowercaseSearch)
      )
    }) || []

  return (
    <>
      <Helmet>
        <title>RAMO - Team</title>
      </Helmet>
      <RAMOMembersTemplate
        // Workspace props
        logoPreview={logoPreview}
        onLogoSelect={handleUpdateLogo}
        onLogoRemove={handleRemoveLogo}
        // Members list props
        members={filteredMembers}
        isLoading={isLoading}
        isFetchingNextPage={isFetchingNextPage}
        hasNextPage={hasNextPage}
        onFetchNextPage={fetchNextPage}
        searchTerm={searchTerm}
        onSearch={handleSearch}
      />
    </>
  )
}
